(ns frontend.view.grid.investors-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce investors (r/cursor app-db/views [:investors]))
(defonce modal-state (r/cursor investors [:modals]))
(defonce grid-entities (r/cursor investors [:grid-entities]))
(defonce view-settings (r/cursor investors [:view-settings]))
(defonce investor-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor investors [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor investors [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor investors [:schema]))
